import { Component, EventEmitter, Input, Output } from '@angular/core';
import { delay } from 'magma/common/promiseUtils';
import { EntityData, ProjectData, TeamRole } from 'shared/interfaces';
import { EntityToolbarButton, getToolbar } from 'util/entities-toolbar';

@Component({
  selector: 'entity-actions-menu',
  templateUrl: 'entity-actions-menu.component.pug',
  styleUrls: ['./entity-actions-menu.component.scss'],
  host: { 'class': 'dropdown-menu context-menu dropdown-wide' },
})
export class EntityActionsMenuComponent {
  @Input() roles: TeamRole[] = [];
  @Input() entity!: EntityData | EntityData[];
  @Input() project!: ProjectData | undefined;
  @Input() isBinFolder = false;
  @Output() action = new EventEmitter<EntityToolbarButton>();

  private _buttons: EntityToolbarButton[] | undefined;
  private _buttonsEntity?: EntityData | EntityData[];
  get buttons() {
    if (this._buttonsEntity !== this.entity) {
      this._buttonsEntity = this.entity;

      this._buttons = getToolbar(this.entity, this.roles, this.project, this.isBinFolder);
    }
    return this._buttons;
  }
  
  get items() {
    return Array.isArray(this.entity) ? this.entity.length : 1;
  }

  async execAction(button: EntityToolbarButton) {
    if (!button.disabled || button.allowClick) {
      this.action.emit(button);

      if (button.clickedTitle) {
        button.clicked = true;
        await delay(1000);
        button.clicked = false;
      }
    }
  }
}
